import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { HemsFeaturesPresentSincePayload } from '../../../projects/client';
import { AnalyticsSelectors } from './analytics.selectors';
import { AnalyticsActions } from './analytics.actions';
import { Observable } from 'rxjs';
import { AvailableFeature } from './analytics.model';

@Injectable({ providedIn: 'root' })
export class AnalyticsStore {
  constructor(public store: Store<AppState>) {}

  selectPropertySinceDataLoaded$ = this.store.select(
    AnalyticsSelectors.selectPropertySinceDataLoaded
  );

  selectEarlierstAvailableChronosFeature$ = this.store.select(
    AnalyticsSelectors.selectEarlierstAvailableChronosFeature
  );
  selectEarlierstAvailableHemsFeature$ = this.store.select(
    AnalyticsSelectors.selectEarlierstAvailableHemsFeature
  );
  selectEarlierstDateFeatureForHemsAnalysisTab$ = this.store.select(
    AnalyticsSelectors.selectEarlierstDateFeatureForHemsAnalysisTab
  );

  getAvailableChronosFeature(featureName: string): Observable<AvailableFeature> {
    return this.store.select(AnalyticsSelectors.selectAvailableChronosFeature(featureName));
  }

  loadAvailableChronosFeaturesForDevice(gateway_id: string): void {
    this.store.dispatch(AnalyticsActions.loadAvailableChronosFeatures.attempt({ gateway_id }));
  }

  triggerGetHemsFeaturesPresentSince(
    hemsFeaturesPresentSincePayload: HemsFeaturesPresentSincePayload
  ): void {
    this.store.dispatch(
      AnalyticsActions.hemsFeaturesPresentSince.attempt({ hemsFeaturesPresentSincePayload })
    );
  }
}
